import Utils from '../../modules/utils'

const reopen = (id, callbackFunc) => {
  const url = 'reopen_vpos'
  const data = {id}
  Utils.post(url, data, callbackFunc)
}

export {reopen}
